import { BookOpen, LifeBuoy, Mail, MessageCircle } from "lucide-react"
import { Card, CardContent } from "@univdiam/ui/components/card"

const HelpCenter = () => {
    return (
        <div className="w-full max-w-[800px] mx-auto p-4 md:p-[24px]">
            {/* Header */}
            <div className="flex items-center gap-3 mb-8">
                <div className="bg-primary/10 p-3 rounded-lg">
                    <BookOpen className="w-8 h-8 text-primary" strokeWidth={1.5} />
                </div>
                <div>
                    <h1 className="text-2xl font-semibold">Help Center</h1>
                    <p className="text-muted-foreground text-sm">We're building resources to help you</p>
                </div>
            </div>

            {/* Coming Soon Card */}
            <Card className="mb-8 border-dashed border-2 border-primary/20 bg-primary/5">
                <CardContent className="p-8 text-center">
                    <div className="inline-flex items-center justify-center w-16 h-16 rounded-full bg-primary/10 mb-4">
                        <LifeBuoy className="w-8 h-8 text-primary" strokeWidth={1.5} />
                    </div>
                    <h2 className="text-xl font-semibold mb-2">Coming Soon!</h2>
                    <p className="text-muted-foreground max-w-md mx-auto leading-relaxed">
                        We're working on helpful resources and documentation to assist you.
                        Please check back later for FAQs, guides, and support articles.
                    </p>
                </CardContent>
            </Card>

            {/* Support Options */}
            <div>
                <h3 className="text-lg font-semibold mb-4">Need immediate help?</h3>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                    <Card className="cursor-pointer hover:shadow-md transition-shadow">
                        <CardContent className="p-5 flex items-start gap-4">
                            <div className="bg-primary/10 p-2.5 rounded-lg shrink-0">
                                <Mail className="w-5 h-5 text-primary" strokeWidth={1.5} />
                            </div>
                            <div>
                                <h4 className="font-semibold mb-1">Email Support</h4>
                                <p className="text-sm text-muted-foreground">
                                    Reach out to our support team via email
                                </p>
                                <a
                                    href="mailto:support@universaldiamonds.net"
                                    className="text-sm text-primary font-medium mt-1 inline-block hover:underline"
                                >
                                    support@universaldiamonds.net
                                </a>
                            </div>
                        </CardContent>
                    </Card>

                    <Card className="cursor-pointer hover:shadow-md transition-shadow">
                        <CardContent className="p-5 flex items-start gap-4">
                            <div className="bg-primary/10 p-2.5 rounded-lg shrink-0">
                                <MessageCircle className="w-5 h-5 text-primary" strokeWidth={1.5} />
                            </div>
                            <div>
                                <h4 className="font-semibold mb-1">Contact Admin</h4>
                                <p className="text-sm text-muted-foreground">
                                    Speak with your account administrator
                                </p>
                                <p className="text-sm text-muted-foreground mt-1">
                                    Available through your account dashboard
                                </p>
                            </div>
                        </CardContent>
                    </Card>
                </div>
            </div>
        </div>
    )
}

export default HelpCenter
